import { House, HouseApiResponse } from '../types/house';

const DETAILS_API_URL = 'https://raspy-block-88b3.patrick-lipp-nz.workers.dev/property';

const parseShortValue = (val: string | undefined): number => {
  if (!val) return 0;
  const cleanVal = val.replace(/[$,]/g, '');
  const multiplier = cleanVal.toUpperCase().endsWith('M') ? 1000000 : 
                     cleanVal.toUpperCase().endsWith('K') ? 1000 : 1;
  const num = parseFloat(cleanVal.replace(/[MKmk]/g, ''));
  return isNaN(num) ? 0 : num * multiplier;
};

export const fetchHouseDetails = async (url: string): Promise<Partial<House>> => {
  try {
    const response = await fetch(DETAILS_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url, debug: false }),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch house details');
    }

    const data: HouseApiResponse = await response.json();

    if (!data.ok || !data.property_details) {
      throw new Error('Invalid API response');
    }

    const details = data.property_details;

    return {
      address: details.display_address || details.address || 'Unknown Address',
      priceRangeLow: parseShortValue(details.display_estimated_lower_value_short),
      priceRangeHigh: parseShortValue(details.display_estimated_upper_value_short),
      estimate: details.capital_value || parseShortValue(details.display_estimated_value_short),
      bedrooms: details.num_bedrooms || 0,
      bathrooms: details.num_bathrooms || 0,
      parking: details.num_car_spaces || details.garage_parking || 0,
      propertySize: details.floor_area || 0,
      landSize: details.land_area || 0,
      imageUrl: details.cover_image_url || '',
      sourceUrl: data.sourceUrl || url,
      
      // Extended Details
      displayPrice: data.display_price,
      capitalValue: details.capital_value,
      improvementValue: details.improvement_value,
      landValue: details.land_value,
      rentalAppraisalLow: parseShortValue(details.display_estimated_rental_lower_value_short),
      rentalAppraisalHigh: parseShortValue(details.display_estimated_rental_upper_value_short),
      rentalYield: details.estimated_rental_yield,
      legalDescription: details.legal_description,
      ownershipType: details.ownership_type,
      certificateOfTitle: details.certificate_of_title,
      decadeBuilt: details.decade_built,
      buildingConstruction: details.building_construction,
      contour: details.contour,
      siteCoverage: details.building_site_coverage,
      hasDeck: details.has_deck,
      hasLaundry: details.has_laundry_or_workshop,
      viewType: details.view_type,
      street: details.street,
      suburb: details.suburb,
      city: details.city,

      // New Fields
      lat: data.point?.lat,
      long: data.point?.long,
    };
  } catch (error) {
    console.error('Error fetching house details:', error);
    throw error;
  }
};
